import Info from "../models/user-model";
import { SET_DATA, UPDATE_DATA, DEACTIVATE_USER } from "./actions";
import { LOGOUT } from "./authActions";

const initialState = {
    userData: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_DATA:
            const userInfo = new Info(
                action.userData.id,
                action.userData.name,
                action.userData.emailAddress,
                action.userData.message,
                action.userData.emailAddressRecipient,
                action.userData.dateLastAlive,
                action.userData.activeUser,
                action.userData.disclosed
                )
                
                return {
                    ...state,
                    userData: userInfo
                }
        case UPDATE_DATA: 
            const updatedData = new Info(
                action.userData.id,
                action.userData.name,
                action.userData.emailAddress,
                action.userData.message,
                action.userData.emailAddressRecipient,
                action.userData.dateLastAlive,
                state.userData.activeUser,
                state.userData.disclosed
                )

                return {
                    ...state,
                    userData: updatedData
                }
        case DEACTIVATE_USER:
            const updatedNewData = new Info(
                state.userData.id,
                state.userData.name,
                state.userData.emailaddress,
                state.userData.message,
                state.userData.emailaddressRecipient,
                state.userData.dateLastAlive,
                action.userData.activeUser,
                state.userData.disclosed
                )

                return {
                    state: initialState,
                    userData: updatedNewData
                }

        case LOGOUT: 
            return initialState
        default: 
             return state;
    }
};